import React from 'react';
import { useIntl } from 'react-intl';
import { Container } from 'reactstrap';
import { ReactComponent as IconPlay } from '@whitelabel/media/icons/small/play.svg';
import { ReactComponent as IconExternalLink } from '@whitelabel/media/icons/small/externallink.svg';
import { StyledSlideWrapper, StyledGridBlockCard, StyledGridContainer } from './styledLogoSlideBlock';
import { ILogoSlideBlock } from './types';
import messages from './messages';

const LogoSlideBlock = ({ title, logos }: ILogoSlideBlock): JSX.Element => {
  const { formatMessage, locale } = useIntl();
  return (
    <StyledSlideWrapper>
      <Container>
        <p>{title}</p>
        <StyledGridContainer>
          {logos.map(({ logo, demoLink, isComingSoon }) => (
            <StyledGridBlockCard
              $isComingSoon={isComingSoon}
              key={logo.image.file}
              className="logo-status"
              target={demoLink ? '_blank' : undefined}
              tabIndex={demoLink ? 0 : -1}
              rel="noopener noreferrer"
              to={demoLink ? `/${locale}${demoLink}` : '?show=getapp'}
            >
              <img className="partner-logo" src={logo.image.file} alt={logo.altText} />
              {isComingSoon && <span className="logo-status">— {formatMessage(messages.statusComingSoon)} —</span>}
              {!isComingSoon && (
                <span className="logo-status logo-icon">
                  {demoLink ? (
                    <>
                      <IconPlay />
                      {formatMessage(messages.statusDemo)}
                    </>
                  ) : (
                    <>
                      <IconExternalLink />
                      {formatMessage(messages.statusGetApp)}
                    </>
                  )}
                </span>
              )}
            </StyledGridBlockCard>
          ))}
        </StyledGridContainer>
      </Container>
    </StyledSlideWrapper>
  );
};

export default LogoSlideBlock;
